document.addEventListener("DOMContentLoaded", function () {
  var variantButtons = document.querySelectorAll('.product-variant-button');
  
  variantButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var variantId        = this.getAttribute('data-variant-id');
      var variantPrice     = this.getAttribute('data-variant-price');
      var variant_compare  = this.getAttribute('data-variant-compare');
      var variantInventory = this.getAttribute('data-inventory');
      var variant_image    = this.getAttribute('data-variant-image');
      var varUrl           = this.getAttribute('data-product-url');
      
      var variant__price          = this.getAttribute("variant-price");
      var variant___compare__price = this.getAttribute("compare-price");

      var container               = this.closest('.card__content');
      var productVariantIdInput   = container.querySelector('.product-variant-id');
      var cartVariantPriceElement = container.querySelector('.cart-variant-price');
      var priceVariantElement     = container.querySelector('.price-item--sale');
      var secondPriceElemnt       = container.querySelector('.price-item--regular');
      var priceVariantElementComp = container.querySelector('.price-itme-cop-cstm');
      var mainBadge               = this.closest(".card-wrapper").querySelector(".card__badge .badge");
      var productSelectedLink     = container.closest('.card-wrapper')?.querySelector('.cstm_submit_btn');
      var soldOutMsg              = container.querySelector('.sold-out-message');
      var addToCartBtn            = container.querySelector('.cstm_submit_btn');
      var cardWrapper = this.closest('.card-wrapper');
      var media = cardWrapper?.querySelector('.card__media, .media');
      var img = media?.querySelector('img');

      var group = this.closest('.product-variant-buttons');
      group.querySelectorAll('.product-variant-button').forEach(btn => {
        btn.classList.remove('active');
      });
      this.classList.add('active');
      if (productSelectedLink) productSelectedLink.setAttribute('href', varUrl);
      if (productVariantIdInput) productVariantIdInput.value = variantId;
      if (cartVariantPriceElement) cartVariantPriceElement.textContent = 'Add to Cart';
      if (priceVariantElement) priceVariantElement.textContent = variantPrice;
      if (secondPriceElemnt) secondPriceElemnt.textContent = variantPrice;
      if (variant_compare && variant_compare !== '') {
        if (priceVariantElementComp) {
          priceVariantElementComp.textContent = variant_compare;
          priceVariantElementComp.style.display = "";
        }
      } else if (priceVariantElementComp) {
        priceVariantElementComp.style.display = "none";
      }
      if (img && variant_image) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-sizes');
        img.removeAttribute('loading');
        var picture = img.closest('picture');
        if (picture) {
          picture.querySelectorAll('source').forEach(function(srcEl) {
            srcEl.removeAttribute('srcset');
            srcEl.removeAttribute('data-srcset');
            srcEl.removeAttribute('sizes');
            srcEl.removeAttribute('data-sizes');
          });
        }
        img.src = variant_image;
        img.setAttribute('srcset', variant_image + ' 1x');
      }
      if (variantInventory && parseInt(variantInventory) > 0) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('sold-out');
        if (soldOutMsg) soldOutMsg.classList.add('hidden');
        if (cartVariantPriceElement) cartVariantPriceElement.classList.remove('hidden');
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('sold-out');
        if (cartVariantPriceElement) cartVariantPriceElement.classList.add('hidden');
        if (soldOutMsg) soldOutMsg.classList.remove('hidden');
        let allButtons = group.querySelectorAll('.product-variant-button');
        let nextAvailable = Array.from(allButtons).find(btn => {
          let inv = parseInt(btn.getAttribute('data-inventory'));
          return inv > 0;
        });
        
        if (nextAvailable && nextAvailable !== this) {
          nextAvailable.click(); 
          return; 
        }
      }
            // Update discount badge
            // Update discount badge
      let price = parseFloat(variant__price);
      let comparePrice = parseFloat(variant___compare__price);

      var saleBadge = cardWrapper.querySelector(".issale_badge");

      if (
        comparePrice &&
        price &&
        comparePrice > price
      ) {

        let discount = Math.floor(((comparePrice - price) * 100) / comparePrice);

        if (mainBadge) {
          mainBadge.classList.remove("hide");

          let offBadge = mainBadge.querySelector('.off_badge');
          if (offBadge) {
            offBadge.innerHTML = `${discount}% OFF`;
          }
        }

        // Discount hai to SALE badge hide
        if (saleBadge) {
          saleBadge.classList.add("hide");
        }

      } else {

        if (mainBadge) {
          mainBadge.classList.add("hide");

          let offBadge = mainBadge.querySelector('.off_badge');
          if (offBadge) {
            offBadge.innerHTML = "";
          }
        }

        // Discount nahi hai to SALE badge show
        if (saleBadge) {
          saleBadge.classList.remove("hide");
        }
      }
    });
  });

  // Auto-click first variant on load
  document.querySelectorAll('.card__content').forEach(function (container) {
    var firstVariantButton = container.querySelector('.product-variant-button');
    if (firstVariantButton) firstVariantButton.click();
  });
});

// Modify variant selector button (image + price + inventory check)
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('click', function (event) {
    if (!event.target.classList.contains('product-variant-button')) return;

    var button                = event.target;
    var variantId             = button.getAttribute('data-variant-id');
    var variantPrice          = button.getAttribute('data-variant-price');
    var variant_compare       = button.getAttribute('data-variant-compare');
    var variantInventory      = button.getAttribute('data-inventory'); // NEW
    var container             = button.closest('.card__content');
    var productVariantIdInput = container.querySelector('.product-variant-id');
    var cartVariantPriceElement = container.querySelector('.cart-variant-price');
    var priceVariantElement   = container.querySelector('.price-item--sale');
    var secondPriceElemnt     = container.querySelector('.price-item--regular');
    var priceVariantElementComp = container.querySelector('.price-itme-cop-cstm');
    var variant_image         = button.getAttribute('data-variant-image');
    var media_image           = button.closest('.card-wrapper')?.querySelector('.media img');
    var soldOutMsg            = container.querySelector('.sold-out-message');
    var addToCartBtn          = container.querySelector('.cstm_submit_btn');

    var siblings = Array.from(button.parentElement.children);
    siblings.forEach(function (sibling) {
      sibling.classList.remove('active');
    });
    button.classList.add('active');
    if (productVariantIdInput) productVariantIdInput.value = variantId;
    if (cartVariantPriceElement) cartVariantPriceElement.textContent = 'Add to Cart ';
    if (priceVariantElement)     priceVariantElement.textContent  = ' ' + variantPrice;
    if (secondPriceElemnt)       secondPriceElemnt.textContent  = '' + variantPrice;
    if (media_image && variant_image) {
      media_image.removeAttribute('srcset');
      media_image.setAttribute('src', variant_image);
    }
    // if (variant_compare == '') {
    //   if (priceVariantElementComp) {
    //     priceVariantElementComp.style.display = "none";
    //   }
    // } else {
    //   if (priceVariantElementComp) {
    //     priceVariantElementComp.style.display = "inline";
    //     priceVariantElementComp.textContent = '' + variant_compare;
    //   }
    // }
    if (variantInventory && parseInt(variantInventory) > 0) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('sold-out');
      if (soldOutMsg) soldOutMsg.classList.add('hidden');
      if (cartVariantPriceElement) cartVariantPriceElement.classList.remove('hidden');
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('sold-out');
      if (soldOutMsg) soldOutMsg.classList.remove('hidden');
      if (cartVariantPriceElement) cartVariantPriceElement.classList.add('hidden');
    }
  });
});

// menu bar bottom sticky 
document.addEventListener('DOMContentLoaded', function () {
      var mobileStickyMenu = document.getElementById('mobileStickyMenu');
      var scrollingTimer;

      function handleScroll() {
        if(mobileStickyMenu) {
          mobileStickyMenu.classList.add('hidden');
          clearTimeout(scrollingTimer);
  
          scrollingTimer = setTimeout(function () {
            mobileStickyMenu.classList.remove('hidden');
          }, 200);
        }
      }

      window.addEventListener('scroll', handleScroll);
      handleScroll();
    });

  document.querySelector('.category-mobile-menu')?.addEventListener('click', function () {
    document.querySelector('[data-link="mobile-menu"]').click();
  });

  document.querySelector('.cart-mobile-menu')?.addEventListener('click', function (e) {
    e.preventDefault();
  });

  document.querySelector('.mb-more')?.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('#your-element-id')?.click();
  });

  var height = document.querySelector('.mobile-sticky-menu')?.offsetHeight;
  var links = document.getElementById('myLinks')
  if(links) links.style.bottom = height + 'px';

  function myFunction() {
    var x = document.getElementById('myLinks');
    if (x.style.display === 'block') {
      x.style.display = 'none';
    } else {
      x.style.display = 'block';
    }
  }

  document.querySelectorAll('.sticky-btn')?.forEach(function (element) {
    element.addEventListener('click', function () {
      var btn = this;
      var active_btn = btn.parentElement.querySelector('.sticky-btn.active12');
      if (active_btn) {
        active_btn.classList.remove('active12');
      }
      btn.classList.add('active12');
    });
  });

  var mb_name;
  document.body.addEventListener('click', function (event) {
    var mbElement = event.target.closest('.mb');
    if (mbElement) {
      mb_name = mbElement.getAttribute('mb-name');
      localStorage.setItem('name', mb_name);
    }
  });

  var name_local = localStorage.getItem('name');
  if (name_local === null) {
    document.querySelector('.mobile-sticky-menu .mb:first-child')?.classList.add('active12');
  }
// js for variant metafield change
document.addEventListener('DOMContentLoaded', function() {
 const varaintoption = document.querySelectorAll('.variant__lable');
  
   varaintoption.forEach(function (button, index) {
        button.addEventListener('click', function () {
          var option_btn = this.getAttribute('id');
          var allMetas = document.querySelectorAll(`.metafield_value .variant_info`);
          if(allMetas.length) {
            allMetas.forEach((meta) => meta.classList.add("active2"));
          }
          var meta_data = this.closest('.page-width').querySelector(`.metafield_value .variant_info#${option_btn}`);
          if(meta_data) meta_data.classList.remove("active2");
          console.log('meta_data', meta_data)
        })
   })
});




document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quantity__input").forEach((input) => {
    input.addEventListener("change", function () {
      if (parseInt(this.value) > 3) {
        this.value = 3;
      }
    });
  });

  // Plus Button Restriction
  document.querySelectorAll('.quantity__button[name="plus"]').forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = this.parentElement.querySelector(".quantity__input");
      let qty = parseInt(input.value);

      if (qty >= 3) {
        input.value = 3;
        return; 
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {

  function showSnackbar() {
    const bar = document.getElementById("snackbar");
    bar.classList.add("show");
    setTimeout(() => bar.classList.remove("show"), 2000);
  }

  document.querySelectorAll(".quantity__input").forEach((input) => {
    input.addEventListener("change", function () {
      if (parseInt(this.value) > 3) {
        this.value = 3;
        showSnackbar();
      }
    });
  });

  document.querySelectorAll('.quantity__button[name="plus"]').forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = this.parentElement.querySelector(".quantity__input");
      let qty = parseInt(input.value);

      if (qty >= 3) {
        input.value = 3;
        showSnackbar();
        return;
      }
    });
  });

  const plusBtn = document.querySelector('button[name="plus"]');
  const qtyInput = document.querySelector('input[name="quantity"]');
  const qtyCartSpan = document.querySelector('.quantity-cart');
  const addToCartBtn = document.querySelector('button[name="add"]');
  console.log("qtyCartSpan",qtyCartSpan);

  function updateButtons() {
    const qtyInputVal = qtyInput ? parseInt(qtyInput.value, 10) : 0;
    const qtyCartVal = qtyCartSpan ? parseInt(qtyCartSpan.textContent.trim(), 10) : 0;

    // if (qtyCartVal === 3) {
    //   addToCartBtn.setAttribute("disabled", "disabled");
    // } else {
    //   addToCartBtn.removeAttribute("disabled");
    // }

    if (qtyInputVal >= 3 || qtyCartVal >= 3) {
      plusBtn.setAttribute("disabled", "disabled");
    } else {
      plusBtn.removeAttribute("disabled");
    }
    // console.log("qtyCartSpan",qtyCartSpan);
  }

  updateButtons();

  if (qtyInput) {
    qtyInput.addEventListener("change", updateButtons);
    qtyInput.addEventListener("keyup", updateButtons);
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function () {
      setTimeout(function () {
        const qtyCartVal = qtyCartSpan ? parseInt(qtyCartSpan.textContent.trim(), 10) : 0;
        if (qtyCartVal >= 3) showSnackbar();
        updateButtons();
      }, 500);
    });
  }

});
document.addEventListener('DOMContentLoaded', function () {

  async function updateAddToCartButtons() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      document.querySelectorAll('form[action="/cart/add"]').forEach(form => {

        const variantInput = form.querySelector('input[name="id"]');
        const addToCartBtn = form.querySelector(
          '.product-form__submit, .quick-add__submit, button[name="add"]'
        );

        if (!variantInput || !addToCartBtn) return;

        const variantId = variantInput.value;

        let variantQtyInCart = 0;

        cart.items.forEach(item => {
          if (String(item.variant_id) === String(variantId)) {
            variantQtyInCart += item.quantity;
          }
        });

        // Add to Cart disable at 3
        addToCartBtn.disabled = variantQtyInCart >= 3;

        // Quantity input always enabled
        form.querySelectorAll(
          '.quantity__input, .quantity input, quantity-input input'
        ).forEach(input => {
          input.disabled = false;
        });

        // Minus button always enabled
        form.querySelectorAll(
          '.quantity__button[name="minus"], .quantity button[name="minus"]'
        ).forEach(btn => {
          btn.disabled = false;
        });

        // Plus button disable at 3
        form.querySelectorAll(
          '.quantity__button[name="plus"], .quantity button[name="plus"]'
        ).forEach(btn => {
          btn.disabled = variantQtyInCart >= 3;
        });

      });

    } catch (error) {
      console.error('Cart check error:', error);
    }
  }

  updateAddToCartButtons();

  document.addEventListener('change', function () {
    setTimeout(updateAddToCartButtons, 300);
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.product-form__submit') ||
      e.target.closest('.quick-add__submit') ||
      e.target.closest('.quantity__button')
    ) {
      setTimeout(updateAddToCartButtons, 500);
    }
  });

  document.addEventListener('cart:updated', updateAddToCartButtons);

  setInterval(updateAddToCartButtons, 2000);
});

document.addEventListener('DOMContentLoaded', function () {

  async function updateAddToCartButtons() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      document.querySelectorAll('form[action="/cart/add"]').forEach(form => {

        const variantInput = form.querySelector('input[name="id"]');
        const addToCartBtn = form.querySelector(
          '.product-form__submit, .quick-add__submit, button[name="add"]'
        );

        if (!variantInput || !addToCartBtn) return;

        const variantId = variantInput.value;

        let variantQtyInCart = 0;

        cart.items.forEach(item => {
          if (String(item.variant_id) === String(variantId)) {
            variantQtyInCart += item.quantity;
          }
        });

        // Add to Cart disable at 3
        addToCartBtn.disabled = variantQtyInCart >= 3;

        // Quantity input always enabled
        form.querySelectorAll(
          '.quantity__input, .quantity input, quantity-input input'
        ).forEach(input => {
          input.disabled = false;
        });

        // Minus button always enabled
        form.querySelectorAll(
          '.quantity__button[name="minus"], .quantity button[name="minus"]'
        ).forEach(btn => {
          btn.disabled = false;
        });

        // Plus button disable at 3
        form.querySelectorAll(
          '.quantity__button[name="plus"], .quantity button[name="plus"]'
        ).forEach(btn => {
          btn.disabled = variantQtyInCart >= 3;
        });

      });

    } catch (error) {
      console.error('Cart check error:', error);
    }
  }

  updateAddToCartButtons();

  document.addEventListener('change', function () {
    setTimeout(updateAddToCartButtons, 300);
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.product-form__submit') ||
      e.target.closest('.quick-add__submit') ||
      e.target.closest('.quantity__button')
    ) {
      setTimeout(updateAddToCartButtons, 500);
    }
  });

  document.addEventListener('cart:updated', updateAddToCartButtons);

  setInterval(updateAddToCartButtons, 2000);
});



// // Disable keyboard shortcuts to prevent inspection
// document.addEventListener('keydown', function(event) {
//   if (event.keyCode == 123 ||  // F12
//       (event.ctrlKey && event.shiftKey && event.keyCode == 73) ||  // Ctrl+Shift+I
//       (event.ctrlKey && event.keyCode == 85) ||  // Ctrl+U
//       (event.ctrlKey && event.shiftKey && event.keyCode == 67) ||  // Ctrl+Shift+C
//       (event.metaKey && event.altKey && event.keyCode == 73) ||  // Meta+Alt+I (Cmd+Option+I on Mac)
//       // (event.ctrlKey && event.shiftKey && event.keyCode == 75) ||  // Ctrl+Shift+K
//       (event.ctrlKey && event.shiftKey && event.keyCode == 74) ||  // Ctrl+Shift+J
//       (event.ctrlKey && event.shiftKey && event.keyCode == 83)) {  // Ctrl+Shift+S
//     event.preventDefault();
//   }
// });
// document.addEventListener('contextmenu', function(event) {
//   event.preventDefault();
// });
